import React, { useEffect, useState } from "react";
import PayrollModulePage from "../../../../entities/DashboardPage/HRModule/PayrollModulePage";
import AuthService from "../../../../api/AuthService";
import LoaderHelper from "../../../../utils/Loader/LoaderHelper";
import { useAlert } from "../../../../context/AlertContext";

const PayrollModule = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const { showAlert } = useAlert();
  const [page, setPage] = useState(1);
  const [count, setCount] = useState("");
  const [permission, setPermission] = useState(null);
  const role = localStorage.getItem("role");
  const employeeId = localStorage.getItem("employeeId");

  // Fetch permissions from API only for Employee role
  const fetchPermissions = async () => {
    if ((role === "Employee" || role === "employee") && employeeId) {
      try {
        const permissionResult = await AuthService.getEmployeePermission(employeeId);
        if (permissionResult?.success && permissionResult?.data) {
          const permissions = permissionResult?.data;
          setPermission(permissions);
        }
      } catch (error) {
        console.error("Error fetching permissions:", error);
      }
    } else {
      // For Admin/SuperAdmin, use localStorage
      const permissionObj = localStorage.getItem("permission");
      setPermission(permissionObj ? JSON.parse(permissionObj) : null);
    }
  };

  useEffect(() => {
    fetchPermissions();
    
    // Listen for permission updates
    const handlePermissionUpdate = () => {
      fetchPermissions();
    };
    
    window.addEventListener("permissionUpdated", handlePermissionUpdate);
    return () => {
      window.removeEventListener("permissionUpdated", handlePermissionUpdate);
    };
  }, []);

  useEffect(() => {
    if (permission !== null || role !== "Employee" && role !== "employee") {
      getPayrollList("", "", "", page);
    }
  }, [page, permission])

  const getPayrollList = async (text, filter, sort, page) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getPayrollList(text, filter, sort, page);
      if (result?.success) {
        let payrolls = result?.data?.payrolls || [];
        
        // Filter data based on permissions for Employee role
        if ((role === "Employee" || role === "employee") && employeeId && permission) {
          const hasViewPermission = permission?.payroll?.isView === true;
          const hasEditPermission = permission?.payroll?.isEdit === true;
          
          // If employee has edit permission, show all payrolls (like admin)
          if (hasEditPermission) {
            setCount(result?.data?.total);
          } else if (hasViewPermission) {
            // If only view permission, filter to show only own payrolls
            // Note: Payrolls might have employee array, filter based on that
            payrolls = payrolls.filter((payroll) => 
              payroll?.employeeDetails?.some((emp) => emp?._id === employeeId || emp?.userId === employeeId)
            );
            setCount(payrolls.length);
          } else {
            // No view permission, show nothing
            payrolls = [];
            setCount(0);
          }
        } else {
          setCount(result?.data?.total);
        }
        
        setData(payrolls);
        setFilteredData(payrolls);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleSearch = (text, filter, sort) => {
    text ? getPayrollList(text) : filter ? getPayrollList("", filter) : sort ? getPayrollList("", "", sort) : null
  }

  const handleDelete = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.deletePayroll(id);
      if (result?.success) {
        getPayrollList();
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "success");
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handlePayrollStatus = async (id, status) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.handlePayrollStatus(id, status);
      if (result?.success) {
        getPayrollList();
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "success");
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  }
  
  return (
    <PayrollModulePage permission={permission?.payroll?.isEdit || role === "Admin" || role === "SuperAdmin"} role={role} getPayrollList={getPayrollList} handleSearch={handleSearch} count={count} page={page} setPage={setPage} data={filteredData.length > 0 ? filteredData : data} handleDelete={handleDelete} handlePayrollStatus={handlePayrollStatus} />
  )

}

export default PayrollModule;
